import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { ModalDialog, useModalDialogContext } from "../Modal";
import { Button } from "../../button/Button";
import { NotMobile } from "../../../hocs/Responsive";

export const CommonModalFooter = ({
  submitButtonType,
  submitMessage,
  cancelMessage,
  autoFocus,
}) => {
  const { disabled, submit, reject } = useModalDialogContext();

  return (
    <ModalDialog.Footer>
      <NotMobile>
        <ModalDialog.Control>
          <Button
            onClick={reject}
            color={"secondary"}
            size={"large"}
            autoFocus={autoFocus}
          >
            {cancelMessage}
          </Button>
        </ModalDialog.Control>
      </NotMobile>
      <ModalDialog.Control>
        <Button
          color={submitButtonType}
          disabled={disabled}
          onClick={submit}
          size={"large"}
        >
          {submitMessage}
        </Button>
      </ModalDialog.Control>
    </ModalDialog.Footer>
  );
};

CommonModalFooter.defaultProps = {
  submitButtonType: "primary",
  submitMessage: <FormattedMessage id="save" />,
  cancelMessage: <FormattedMessage id="cancel" />,
  autoFocus: false,
};

CommonModalFooter.propTypes = {
  submitButtonType: PropTypes.string,
  autoFocus: PropTypes.bool,
  submitMessage: PropTypes.node.isRequired,
  cancelMessage: PropTypes.node.isRequired,
};
